import { Button, DialogOverlay, DialogOverlayActions, Paragraph } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { deleteArtifact, deleteTombstonedArtifact } from '../../../services/artifactService'
import useNotifications from '../../../hooks/useNotifications'
import { SCREENING_STATE } from '../util/artifactsConstants'

export default function DeleteArtifactOverlay({ artifactId, patronId, screeningState, onSuccess, ...overlay }) {
  const { t } = useTranslation()
  const { error, ok } = useNotifications()

  const submitOnClick = async () => {
    overlay.close()
    const deleteFunc =
      screeningState === SCREENING_STATE.DELETED
        ? () => deleteTombstonedArtifact(artifactId, patronId)
        : () => deleteArtifact(artifactId)
    try {
      await deleteFunc()
      ok(t('success', 'Success'))
      onSuccess && onSuccess()
    } catch (err) {
      error(
        t('artifacts.error.errorDeletingArtifact', {
          defaultValue: `Error deleting artifact: ${err.message || ''}`,
          message: err.message || '',
        }),
        err
      )
    }
  }

  return (
    <DialogOverlay title={t('action.delete', 'Delete')} {...overlay}>
      <Paragraph size="sm">
        {t(
          'artifacts.deleteConfirmation',
          'Artifacts deleted by data admins cannot be restored. Are you sure you want to permanently delete this artifact?'
        )}
      </Paragraph>
      <DialogOverlayActions>
        <Button onClick={submitOnClick} emphasis="high">
          {t('action.submit', 'Submit')}
        </Button>
        <Button onClick={overlay.close}>{t('action.cancel', 'Cancel')}</Button>
      </DialogOverlayActions>
    </DialogOverlay>
  )
}
